import type { Ratio } from './types.ts';

// Aritmética entera para enteros no negativos; exacta mientras num × base quepa en un entero seguro.
const floorDiv = (a: number, b: number): number => (a - (a % b)) / b;
const ceilDiv = (a: number, b: number): number => floorDiv(a + b - 1, b);

/** Menor entero x tal que x > r × n (estricto) o x >= r × n (no estricto). */
export function minCount(n: number, r: Ratio, strict: boolean): number {
  return strict ? floorDiv(r.num * n, r.den) + 1 : ceilDiv(r.num * n, r.den);
}

export const isHalf = (r: Ratio): boolean => r.num * 2 === r.den;
